import OfferedValues, { OfferedValuesProps } from './OfferedValues';

export type { OfferedValuesProps };
export default OfferedValues;
